import React from 'react';
import {
  FormFeedback,
  Input
} from 'reactstrap';

const TextField = ({
  type,
  label,
  error,
  value,
  onChange,
  className,
  ...props
}) => {
  return (
    <div>
      <Input
        className={className}
        type={type}
        value={value}
        onChange={onChange}
        invalid={error && error ? true : false}
        {...props}
      />
      {error &&
        <FormFeedback>{error}</FormFeedback>
      }
    </div>
  )
}

TextField.defaultProps = {
  type: 'text',
  label: '',
  error: '',
  value: '',
  className: '',
};

export default TextField;